import { useMutation } from "@apollo/client";

import { GqlPlannerV2AreaStatus } from "~/__generated__/graphql/types";

import { MapEditorPlannerAreaPanel_PlannerAreaUpdateDocument } from "../../mutations.generated";

export type PlannerAreaSettingsFormData = {
    name: string;
    status: GqlPlannerV2AreaStatus;
    descriptionClient: string | null;
    descriptionFieldworker: string | null;
    descriptionInternal: string | null;
};

export function useUpdatePlannerAreaSettingsMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaUpdateDocument);

    const updatePlannerAreaSettings = (plannerAreaId: string, data: PlannerAreaSettingsFormData) =>
        mutate({
            variables: {
                input: {
                    plannerAreaId,
                    data,
                },
            },
        });

    return [updatePlannerAreaSettings, result] as const;
}
